module.exports = __webpack_public_path__ + "static/media/ikea-plaintextlogo.c257d493.svg";